var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPresent = function SvgPresent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M68.96 8.046c-1.518-3.567-3.745-5.551-6.656-5.953-8.225-1.105-16.5 10.8-16.93 11.353-.152.2-2.354 1.28-2.354 1.507v8.163c0 .602.506 1.08 1.113 1.08h18.728c.177-.025 4.48-.628 6.656-4.295 1.696-2.964 1.519-6.958-.556-11.855m-34.445 5.4c-.43-.553-8.731-11.805-16.93-10.7-2.911.402-5.164 2.386-6.657 5.953-2.075 4.897-2.252 8.891-.506 11.855 2.177 3.692 6.479 4.27 6.656 4.295h18.728c.607 0 1.114-.478 1.114-1.08v-8.163c-.051-.251-2.253-1.984-2.405-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M72.68 78.02H7.185c-2.885 0-5.24-2.335-5.24-5.199V29.395c0-2.863 2.355-5.2 5.24-5.2h65.522c2.885 0 5.239 2.337 5.239 5.2V72.82c-.025 2.864-2.38 5.2-5.264 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M34.515 24.196h10.857V78.02H34.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M34.515 13.446h10.857v10.775H34.515z"
  }))));
};
export default SvgPresent;